import React, { useEffect } from 'react'
import { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import isGHMC from '../../../Common/helper/helpar';
import { Modal } from 'react-bootstrap';

const GVPHotspotInnerCount = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const data = location.state;
    const [filteredRows, setFilteredRows] = useState([]);
    const [collectionPointTypeName, setCollectionPointTypeName] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [page, setPage] = useState(0);
    const isProd = isGHMC();
    const [showImagePreview, setShowImagePreview] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        if (data && data.response) {
            console.log(data)
            setFilteredRows(data.response);  // Assign the response array to filteredRows
            setCollectionPointTypeName(data.collectionPointTypeName)
        }
    }, [data]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 100));
        setPage(0);
    };

    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const currentRows = filteredRows.slice(startIndex, endIndex);


    const downloadAsExcel = async () => {
        // Determine if the data is sorted or not

        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("GVP Hotspot Report");

        // Define styles
        const boldFont = { bold: true };

        // Get current date and time
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `GVP ${collectionPointTypeName} Report Generated on: ${formattedDate}, ${formattedTime}`;

        // Add the downloadDateTime to the worksheet
        worksheet.addRow(["", "", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 6);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        // Add "Zone Details" header
        worksheet.addRow(["", "", `GVP ${collectionPointTypeName} Report`, ""]);
        worksheet.mergeCells(2, 2, 2, 6);
        worksheet.getCell(2, 2).value = `GVP ${collectionPointTypeName} Report`;
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        // Define table headers
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "Zone",
            "Circle",
            "Ward",
            "Point Type",
            "GVP Point Name",
            "Cleaned By",
            "Vehicle Type",
            "Vehicle Capacity",
            "Driver(Name & Mobile)",
            "Cleaned Date and Time",
            "Before Latitude",
            "Before Longitude",
            "After Latitude",
            "After Longitude",
        ]);
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "left" };
            if (colNumber >= 1 && colNumber <= 15) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" }, // Background color
                    bgColor: { argb: "FFFFFFFF" } // Text color
                };
            }
        });

        // Add data rows
        filteredRows.forEach((row, index) => {
            worksheet.addRow([
                index + 1,
                row.zoneName?? "N/A",
                row.circleName?? "N/A",
                row.wardName,
                "N/A",
                collectionPointTypeName,
                row.vehicleNumber?? "N/A",
                row.vehicleTypeName?? "N/A",
                row.vehicleCapacityName?? "N/A",
                row.driverName + "-" + row.mobileNumber,
                row.createdDate?? "N/A",
                row.beforeLatitude?? "N/A",
                row.beforeLongitude?? "N/A",
                row.afterLatitude?? "N/A",
                row.afterLongitude?? "N/A",
            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.alignment = { horizontal: "left" };
            });
        });

        // Set column widths dynamically based on content
        worksheet.columns = [
            { width: 5 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 40 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 40 },
            { width: 30 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },

        ];

        // Save the workbook to a file
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `GVP${(collectionPointTypeName).trim()}Report.xlsx`;
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };

    // Function to handle image click
    const handleImageClick = (imageUrl) => {
      setSelectedImage(imageUrl);
      setShowImagePreview(true);
    };
  
    // Function to close the modal
    const handleModalClose = () => {
        setShowImagePreview(false);
      setSelectedImage(null);
    };
    const headerStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }
    const cellStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                      <div className="top-header page-title">
                        <span>GVP {collectionPointTypeName} Report</span>
                      </div>
                        <div className="page-header"></div>
                        <div class="row" style={{ textAlign: "justify" }}>
                        </div>
                        <div className="card">
                            <div className="card-body p-3">
                                <div className="d-flex justify-content-end mt-3 mb-3">
                                    <button
                                        variant="contained"
                                        className="btn btn-secondary"
                                        //   color="error" // Red color
                                        onClick={() => navigate(-1)} // Navigate back
                                    // sx={{ marginBottom: '20px',marginTop:'20px',backgroundColor:'red' }} // Add some margin for spacing
                                    >
                                        Back
                                    </button>
                                    <button className="btn btn-excel"
                                        onClick={downloadAsExcel}
                                    >
                                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                    </button>
                                </div>

                                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            width: '100%',
                                            maxHeight: '500px',
                                            border: '1px solid #ccc',
                                        }}
                                    >
                                        <Table sx={{ minWidth: 700, borderCollapse: 'collapse' }}>
                                            <TableHead
                                                className={`${isProd ? 'bg-ghmc' : 'bg-swm'}`}
                                                sx={{
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1,
                                                }}
                                            >
                                                <TableRow sx={{ paddingTop: '20px' }}>
                                                    <TableCell sx={headerStyles}>S.No</TableCell>
                                                    <TableCell sx={headerStyles}>Zone</TableCell>
                                                    <TableCell sx={headerStyles}>Circle</TableCell>
                                                    <TableCell sx={headerStyles}>Ward</TableCell>
                                                    <TableCell sx={headerStyles}>Point Type</TableCell>
                                                    <TableCell sx={headerStyles}>GVP Point Name</TableCell>
                                                    <TableCell sx={headerStyles}>Cleaned By</TableCell>
                                                    <TableCell sx={headerStyles}>Vehicle Type</TableCell>
                                                    <TableCell sx={headerStyles}>Vehicle Capacity</TableCell>
                                                    <TableCell sx={headerStyles}>Driver(Name & Mobile)</TableCell>
                                                    <TableCell sx={headerStyles}>Cleaned Date and Time</TableCell>
                                                    <TableCell sx={headerStyles}>Before Image</TableCell>
                                                    <TableCell sx={headerStyles}>After Image</TableCell>
                                                    <TableCell sx={headerStyles}> Before Latitude</TableCell>
                                                    <TableCell sx={headerStyles}> Before Longitude</TableCell>
                                                    <TableCell sx={headerStyles}> After Latitude</TableCell>
                                                    <TableCell sx={headerStyles}> After Longitude</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {currentRows.length > 0 ? (
                                                    currentRows.map((row, index) => (
                                                        <TableRow
                                                            key={row.sno}
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? 'rgba(0, 69, 84, 0.04)' : '#ffffff',
                                                            }}
                                                        >
                                                            <TableCell sx={cellStyles}>{startIndex + index + 1}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.zoneName}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.circleName}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.wardName}</TableCell>
                                                            <TableCell sx={cellStyles}>N/A</TableCell>
                                                            <TableCell sx={cellStyles}>{collectionPointTypeName}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.vehicleNumber}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.vehicleTypeName}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.vehicleCapacityName}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.driverName} - {row.mobileNumber}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.createdDate}</TableCell>
                                                            <TableCell sx={cellStyles}>
                                                                <img
                                                                    onClick={() => handleImageClick(row.beforeImageURL)}
                                                                    style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: '10px', cursor: "pointer" }}
                                                                    src={row.beforeImageURL}
                                                                    alt="Before Image"
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={cellStyles}>
                                                                <img
                                                                    onClick={() => handleImageClick(row.afterImageURL)}
                                                                    style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: '10px', cursor: "pointer" }}
                                                                    src={row.afterImageURL}
                                                                    alt="After Image"
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={cellStyles}>{row.beforeLatitude}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.beforeLongitude}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.afterLatitude}</TableCell>
                                                            <TableCell sx={cellStyles}>{row.afterLongitude}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={17} sx={{ textAlign: 'center' }}>No data available</TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        component="div"
                                        count={filteredRows.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Paper>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showImagePreview} onHide={handleModalClose} centered>
                <Modal.Header closeButton style={{ marginTop: '5px' }}>
                    <Modal.Title>Image Full Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <img src={selectedImage} alt="Full vehicle" style={{ width: '100%', height: '400px', borderRadius: '5px', objectFit:"contain" }} />
                </Modal.Body>
            </Modal>
        </>
    )
}
export default GVPHotspotInnerCount 